// Show snackbars to the user about the actions he is executing
import IdoniaLocales from '~/locales'

import useLanguageTree from '~/commons/language'
const {t, te} = useLanguageTree()
export default {
  namespaced: true,
  state: {
    queue: [],
    currentSnack: null
  },
  mutations: {
    updateCurrentSnack (state, snack) {
      state.currentSnack = snack
    },
    shiftFromQueue (state) {
      state.queue.shift()
    },
    addToQueue (state, snack) {
      state.queue.push(snack)
    }
  },
  actions: {
    addSnack ({commit, state}, snack) {
      const newSnack = Object.assign({}, {
        text: '',
        action: null,
        position: 'bottom',
        color: '',
        timeout: typeof snack.action === 'undefined' ? 3000 : 6000,
        callback: null
      }, snack)
      if (state.currentSnack === null) {
        commit('updateCurrentSnack', newSnack)
      } else {
        commit('addToQueue', newSnack)
      }
    },
    addCatchSnack ({commit, state, dispatch}, response, options) {
      let err = 'Something went wrong'
      let textArgs = {}
      console.log(te(response.body.error, IdoniaLocales.defaultLocale.code), response.body.error)
      if (response && response.body && response.body.error) {
        let splited = response.body.error.split('^^')
        if (te(splited[0], IdoniaLocales.defaultLocale.code)) {
          err = splited[0]
          if (splited.length > 1) {
            let responseArgs = splited.slice(1)
            for (let i = 0; i < responseArgs.length; i++) {
              textArgs['p' + i.toString()] = t(responseArgs[i])
            }
          }
        }
      }

      let snack = Object.assign({text: err, textArgs}, options)
      dispatch('addSnack', snack)
    },
    addErrSnack ({commit, state, dispatch}, response, options) {
      let err = 'Something went wrong'
      let textArgs = response.params || {}
      if (response.message && te(response.message, IdoniaLocales.defaultLocale.code)) {
        err = response.message

        let snack = Object.assign({ text: err, textArgs }, options)
        dispatch('addSnack', snack)
      }
    },
    shiftFromQueue ({commit}) {
      commit('shiftFromQueue')
    },
    updateCurrentSnack ({commit}, snack) {
      commit('updateCurrentSnack', snack)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/feedback.js